import { combineReducers } from 'redux';

// Reducers
import eventReducer from './reducers/event.reducer';
import facetReducer from './reducers/facets.reducer';
import commonReducer from './reducers/common.reducer';

export const Store =  combineReducers({
	event: eventReducer,
	facet: facetReducer,
	common: commonReducer
});
